<template>
<div style="background:white">
    <div class="home-page-banner">
  <div class="home-page-banner-content">Kartik Chugh & Co.</div>  
</div>

<div class="about-intro-wrapper">
  <h4>Kartik Chugh & Co.</h4>
  <div>We are an accounting firm consisting of corporate strategists, auditors, tax advisory experts, financial and market analysts.
We started as professional firm of Chartered Accountants. This firm is growing and is one of professional consultancy and Audit firm rendering services to Indian and foreign clients. We enhances value for clients by focusing on solutions that are innovative, yet practical and that can be implemented. 
We, at believe in giving highly personalized and customized services to our clients, keeping intact the best of industry standards with lowest possible turn around time.
Our experienced team brings on board a hands-on experience and a practical approach to each business situation by understanding the client’s objectives and identifying potential issues from a strategic as well as tactical perspective.
</div><br>

</div>
<div style="background:#efefef">
<div class="services-head"><h4>Services we offer</h4></div>
<div class="service-wrapper">
        <div class="card" style="width:350px" data-aos="fade-up" >
        <div class="card-image">
          <img src="../assets/payroll.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Assurance</span>
          <p>Receiving input data from client like Attendance, New Joiners’, Resignee, Increment, Incentive, Advance etc... </p>
        </div>
      </div>

         <div class="card" style="width:350px" data-aos="fade-up" >
        <div class="card-image">
          <img src="../assets/court.png">
        </div>
        <div class="card-content">
          <span class="card-title">Direct tax Advisory</span>
          <p>New Company Registration, Online Registration of the employees, Monthly Process, Yearly Process</p>
        </div>
      </div>

         <div class="card" style="width:350px" data-aos="fade-up" >
        <div class="card-image">
          <img src="../assets/company.png">
        </div>
        <div class="card-content">
          <span class="card-title">Indirect tax Advisory</span>
          <p>New Company Registration, Filing of necessary papers online and obtaining PF registration code number...</p>
        </div>
      </div>
</div>
<div style="text-align:center;padding:30px"><button class="see-all-service"><router-link  :to="{ name: 'services', params: {service: 'default' } }" style="color:#FFFFFF">Explore other services</router-link></button></div>
</div>

<div class="why-ecara">
    <div class="container">
			<h3>Why Kartik Chugh & Co.?</h3>
			<hr class="featurette-divider">

			<div class="reason">
				<div class="reason-text" >
						<h2 data-aos="fade-right" >1.&nbsp;&nbsp;<span >Personalised Service</span></h2>
						<p data-aos="fade-right"  >We offer custom made services i.e We make products exactly as you want. We aren’t satisfied until you are satisfied. Even if you wake up at 2 AM worrying about your project, You’d know that we are still working and you have nothing to worry about.</p>
				</div>
				<div class="reason-image">
          <img src="../assets/support.png" style="width:200px"/>
				</div>
			</div>

			<hr class="featurette-divider">

			<div class="reason">
        <div class="reason-image top-image">
          <img src="../assets/punctuality.png" style="width:200px"/>
			  </div>
				<div class="reason-text">
					<h2 data-aos="fade-left"  >2.&nbsp;&nbsp;<span >Always on Time</span></h2>
					<p data-aos="fade-left"  >We are committed to delivering our product on the promised time. We know the importance of timing in a business so we ensure that we deliver our product on the promised time.</p>
			  </div>
        <div class="reason-image bottom-image">
          <img src="../assets/punctuality.png" style="width:200px"/>
			  </div>
			</div>

			<hr class="featurette-divider">

			<div class="reason">
				<div class="reason-text"  >
					<h2 data-aos="fade-right"  >3. &nbsp;&nbsp;<span >Value for money</span></h2>
					<p data-aos="fade-right"  >We at Kartik Chugh & Co. ensures that you get the product at the right cost. Unlike othersWe don’t add any hidden costs that has nothing to do with you . Our systems are designed in a way that offers you the best  services at the best prices.</p>
				</div>
				<div class="reason-image">
          <img src="../assets/value.png" style="width:200px"/>
				</div>
			</div>
			
      <hr class="featurette-divider">
		</div>
</div>


<div style="position:relative">
<div class="noble-cara" data-aos="zoom-in">
<div style="padding-right:25px;">
    <p class="nb-head">Kartik Chugh & Co.</p>
    <p stle="line-height:2"></p>
    <a class="waves-effect waves-teal btn-flat" target="_blank" href="https://panel.kcco.co.in" style="background-color:white">Login</a>
</div>
</div>

</div>

<!-- <div style="margin-left:10%">
  <h4>Clientele & Verticals</h4>
</div> -->
<!-- <div class="services-wrapper container">
    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number1"
            :from="numberFrom[0]"
            :format="theFormat"
            animationPaused
            :to="numberTo[0]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>
            <span><br>Manufacturing</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number2"
            :from="numberFrom[1]"
            :format="theFormat"
            animationPaused
            :to="numberTo[1]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>
            <span><br>Consulting</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number3"
            :from="numberFrom[2]"
            :format="theFormat"
            animationPaused
            :to="numberTo[2]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>
            <span><br>Logistics</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number4"
            :from="numberFrom[3]"
            :format="theFormat"
            animationPaused
            :to="numberTo[3]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>

            <span><br>IT & IT-ES</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number5"
            :from="numberFrom[4]"
            :format="theFormat"
            animationPaused
            :to="numberTo[4]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>

            <span><br>Telecom / Media</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number6"
            :from="numberFrom[5]"
            :format="theFormat"
            animationPaused
            :to="numberTo[5]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>

            <span><br>Retail</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number7"
            :from="numberFrom[6]"
            :format="theFormat"
            animationPaused
            :to="numberTo[6]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>
          <span><br>Startups</span>
        </div>
    </div>

    <div class="card" style="width:250px" data-aos="zoom-in">
        <div class="card-image">
          <img src="../assets/image-counter.png">
        </div>
        <div class="card-content" >
          <number
            class="bold transition"
            :class="{scaleBig: scaleClass}"
            ref="number8"
            :from="numberFrom[7]"
            :format="theFormat"
            animationPaused
            :to="numberTo[7]"
            :duration="duration"
            :delay=2
            easing="Power4.easeOut"
            @complete="completed"/>
            <span><br>Subscribers</span>
        </div>
    </div>
</div> -->

<!-- <div style="padding:50px 0px 100px 0px"> -->
<!-- <div style="padding:15px"><p style="text-align:center;font-weight:600;font-size:24px">Our Clients</p></div> -->
<!-- <div class="clients-wrapper"> -->
    <!-- <div style="width:200px;padding:15px 0px;height:100px" >
        <div >
          <img src="../assets/WT.png" width="65px" >
        </div>
      </div>

      <div style="width:200px;padding:15px 0px;height:100px" >
        <div >
          <img src="../assets/pcunify.png" width="180px" height="90px">
        </div>
      </div>

      <div style="width:200px;padding:15px 0px;height:100px" >
        <div >
          <img src="../assets/worldish.png" width="180px" >
        </div>
      </div>

      <div style="width:200px;padding:15px 0px;height:100px" >
        <div >
          <img src="../assets/uts.svg" width="150px" height="30px">
        </div>
      </div> -->

   

<!-- </div> -->
<!-- </div> -->

<div class="contact">
    <p>Let's create someting together.</p>
    <p>We are working as a team of well experienced and highly professional web and mobile app developers, designers who are able to work on your projects with expertise and innovative ideas. We understand needs and requirements of our clients and we are able to satisfy every client by providing the premium quality services for your enterprise projects.</p>
    <button class="meet"><router-link  to="/contact" style="color:white">Let's meet</router-link></button>
</div>
</div>
</template>

<script>

export default {
  name: "Home",
  props: {
  },
  components: {
      
    },
  data(){
      return{
        numberFrom: [0, 0, 0, 0, 0, 0, 0, 0],
        numberTo: [158, 35, 10, 217, 23, 38, 18, 218],
        duration: 15,
        scaleClass: false
      }
  },
   mounted(){
     this.playAnimation();
  },
  methods:{
    theFormat(number) {
      return number.toFixed(2);
    },
    completed() {
      console.log("Animation ends!");
      this.scaleClass = true;
    },
    playAnimation() {
      this.scaleClass = false;
      this.$refs.number1.play();
      this.$refs.number2.play();
      this.$refs.number3.play();
      this.$refs.number4.play();
      this.$refs.number5.play();
      this.$refs.number6.play();
      this.$refs.number7.play();
      this.$refs.number8.play();
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro");
@import url("https://fonts.googleapis.com/css?family=Montserrat");
/* @import url('./assets/sass/app.scss'); */

body,html{
    font-family: 'Montserrat', sans-serif;
    background:white !important;
}

.home-page-banner{
  background-image:linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)),url("../assets/intro-image.jpg");
  height: 80vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top:-20px;
}
.home-page-banner-content{

 text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-transform: uppercase;
  font-size: 4em;
  font-weight: 900;
  font-family: 'Montserrat', sans-serif;
}
.about-intro-wrapper{
    margin: 8% 10%;
    font-family: 'Montserrat', sans-serif;

}
.about-intro-wrapper h4{
  color:#111e6c;
  font-weight: 600;
  margin: 4% 0px;
}
.about-intro-wrapper div{
  font-size: 15px;
  line-height: 1.5;
  text-align: justify;
}
.card-image img{
  width:25% !important;
  margin-left:auto !important;
  margin-right:auto !important;
  padding:5px !important;
  margin-top: 16px;
}
.card-title{
  position:relative !important;
  color:#111e6c !important;
  font-weight: 600 !important;
  font-size:18px !important;
}
.card{
  font-family: 'Montserrat', sans-serif;
  /* border-radius:10px !important; */
  text-align:center;
  margin:20px;
  border:0px;
  box-shadow:0px 0px 0px;
  background: #efefef;
}
.service-wrapper{
  font-family: 'Montserrat', sans-serif;
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  background:#efefef;
}
.clients-wrapper{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
}
.clients-wrapper div{
  display:flex;
  align-items:center;
  justify-content:center;

}

.services-head h4{
  font-family: 'Montserrat', sans-serif;
  padding:30px 0px;
  font-weight: 600;
  /* color:#111e6c; */
  text-align:center;
  /* margin-top:25px; */
}

.see-all-service{
    padding: 10px 25px;
    border-radius: 3px;
    margin: 10px;
    border: 0px;
    background:tomato;
    color: white;
}
.reason{
    font-family: 'Montserrat', sans-serif;

    display: flex;
    justify-content: space-between;
    padding:30px 0px;
}
.reason-text{
    font-family: 'Montserrat', sans-serif;

    padding:0px 30px;
}
.reason-text h2{
    font-size:24px;
    font-weight:600;
}
.reason-text p{
    color:#888;
    text-align:justify;
    font-size:13px;
}

.featurette-divider{
	margin: 2rem 0;
	-webkit-tap-highlight-color: transparent
}
.why-ecara h3{
    font-family: 'Montserrat', sans-serif;

}
hr{
	margin-top: 1rem;
	margin-bottom: 1rem;
	border: 0;
	box-sizing: content-box;
	height: 0;
	overflow: visible;
	display: block;
	unicode-bidi: isolate;
	margin-block-start: 0.5em;
	margin-block-end: 0.5em;
	margin-inline-start: auto;
	margin-inline-end: auto;
	border-top: 1px solid rgba(0,0,0,.1);
	-webkit-tap-highlight-color: transparent
}
.why-ecara{
    margin:8% 0px;
    margin-bottom:0px;
}
.noble-cara{
    background-image: linear-gradient(rgba(24, 23, 23, 0.6), rgba(24, 24, 24, 0.6)),url("../assets/home-image.jpg");
    background-size: cover;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: white;
    margin:4% 0px;
    padding: 0px 6%;
    font-family: 'Montserrat', sans-serif;
}
.nb-head{
    margin: 0px;
    font-size: 32px;
    font-weight: 700;
}
.meet{
    padding: 10px 35px;
    border: 0px;
    background: tomato;
    color: white;
    border-radius: 4px;
}
.contact p:nth-child(1){
    font-size: 24px;
    font-weight: 600;
    text-align: center;
}
.contact{
    padding: 0px 5% 50px 5%;
    text-align: center;
}
.top-image{
    display:block;
}
.bottom-image{
    display:none;
}
@media (max-width: 768px){
    .reason{
        flex-direction: column-reverse;
        padding:10px 0px;
    }
    .reason-image{
        text-align:center;
    }
    .reason-image img{
        width:75px !important;
    }
    .reason-text{
        padding:0px;
    }
    .nc-image{
        width:75px !important;
    }
    .featurette-divider{
        margin:1rem 0px;
    }
    .top-image{
    display:none;
}
.bottom-image{
    display:block;
}
.reason-text h2{
    font-size:20px;
}
h3, h4{
    font-size:23px;
}
}

.services-wrapper{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  margin:2% auto;
}

</style>